import React from 'react'

const RegionSelect = ({ filter, setFilter, setSearchString }) => {
  return (
    <div className='formField'>
      <label htmlFor='regionSelect'>Region select</label>
      <select
        className='regionSelect shadow'
        name='regionSelect'
        value={filter}
        onChange={(e) => {
          setSearchString('')
          setFilter(e.target.value)
        }}
      >
        <option value='world'>All Countries</option>
        <option disabled>Regions</option>
        <option value='africa'>Africa</option>
        <option value='americas'>Americas</option>
        <option value='antarctic'>Antarctic</option>
        <option value='asia'>Asia</option>
        <option value='europe'>Europe</option>
        <option value='oceania'>Oceania</option>
      </select>
    </div>
  )
}

export default RegionSelect
